import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const testMyDeviceSelector = (state: RootState) => state.amwell.testMyDevice;

export const wizardSelector = createSelector(testMyDeviceSelector, t => t.wizard);
export const wizardErrorSelector = createSelector(testMyDeviceSelector, t => t.error);
export const wizardLoadingSelector = createSelector(testMyDeviceSelector, t => t.loading);
